import { Difficulty } from "shared/games/Difficulty";
import Instrument from "shared/games/instruments/Instrument";
import { Technique } from "shared/games/technique";
import { Game } from "shared/games/types/Game";
import { IsThisCompressorOnAnswerOptions } from "shared/games/types/GameQuestions";
import { LooopAudioFiles } from "shared/games/Looop";
import { User } from "shared/user/types";

interface QuestionShape {
  correct: boolean;
  points: number;
  difficulty: Difficulty;
}

export const apiPostMixPuzzleQuestionPath = `/api/question/mix-puzzle`;
export type ApiPostMixPuzzleQuestionResponse = User;
export interface ApiPostMixPuzzleQuestionParams {
  mix_puzzle_id: number;
  question: QuestionShape;
}

export const apiPostGameQuestionPath = `/api/question/game`;
export type ApiPostGameQuestionResponse = User;
export interface ApiPostGameQuestionParams<
  MetaData extends ApiPostGameQuestionMetaData
> {
  round: {
    unique_identifier: string;
    goal_id?: number;
  };
  question: QuestionShape & {
    game: Game;
    instrument: Instrument;
    technique: Technique;
    metadata: MetaData;
  };
}

export interface ApiPostGameQuestionMetaDataFrequencyFinder {
  question_frequency: number;
  answer_frequency: number;
}

export interface ApiPostGameQuestionMetaDataIsThisCompOn {
  a: keyof LooopAudioFiles;
  b: keyof LooopAudioFiles;
  question_compression: IsThisCompressorOnAnswerOptions;
  answer_compression: IsThisCompressorOnAnswerOptions;
}

export interface ApiPostGameQuestionMetaDataFaderGrader {
  question_volume: number;
  answer_volume: number;
}

export interface ApiPostGameQuestionMetaDataCanYouPan {
  question_pan: number;
  answer_pan: number;
}

export type ApiPostGameQuestionMetaData =
  | ApiPostGameQuestionMetaDataFrequencyFinder
  | ApiPostGameQuestionMetaDataIsThisCompOn
  | ApiPostGameQuestionMetaDataFaderGrader
  | ApiPostGameQuestionMetaDataCanYouPan;
